import React from 'react';
import { graphql } from 'react-relay';

import { t } from '@lingui/macro';

import useI18n from '@zego/i18n/useI18n';
import BaseLayout from '@zego/layouts/BaseLayout';
import withData from '@zego/lib/withData';
import { interpolateString } from '@zego/utils';

import LegalPageLayout from '@zego/components/LegalPageLayout';

import PrivacyCopy from './_copy/_main';

const PrivacyPageFr = ({ viewer }) => {
  const { i18n } = useI18n();

  return (
    <BaseLayout
      viewer={viewer}
      unshiftHeader={false}
      headerIsInitiallyLightOnDark={false}
      title={i18n._(
        t('Privacy Page / Privacy Policy / Title')`Privacy Policy`,
      )}
    >
      <LegalPageLayout
        title={i18n._(
          t('Privacy Page / Privacy Policy / Title')`Privacy Policy`,
        )}
        subtitle="Tout ce que vous devez savoir à propos de vos données personnelles. Tout simplement."
        body={interpolateString(PrivacyCopy, viewer.country)}
      />
    </BaseLayout>
  );
};

export default withData(PrivacyPageFr, {
  query: graphql`
    query PrivacyPageFrQuery($country: String!) {
      viewer {
        country: countryByCode(code: $country) {
          supportEmail
        }
        ...BaseLayout_viewer @arguments(country: $country)
      }
    }
  `,
  getVariables: ({ query }) => {
    return {
      country: query.country,
    };
  },
});
